import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Container, classNames, FlexCenter } from "@opensea/ui-kit";
import { getMediaPropsFromMedia } from "../../../../utils";
import { NarrativeMedia } from "../NarrativeMedia";
import { TextOnly } from "../TextOnly";
import { TextWithMediaFragment } from "./TextWithMedia.fragment";
export function TextWithMedia(t0) {
  const $ = _c(17);
  const {
    module: moduleKey
  } = t0;
  let moduleData;
  let reverse;
  let t1;
  if ($[0] !== moduleKey) {
    moduleData = readFragment(TextWithMediaFragment, moduleKey);
    reverse = moduleData.horizontalTextPosition === "LEFT";
    const media = moduleData.media?.[0];
    t1 = getMediaPropsFromMedia(media);
    $[0] = moduleKey;
    $[1] = moduleData;
    $[2] = reverse;
    $[3] = t1;
  } else {
    moduleData = $[1];
    reverse = $[2];
    t1 = $[3];
  }
  const mediaProps = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("flex grid-cols-16 flex-col lg:grid", "gap-8 py-(--overview-vertical-padding) lg:gap-[var(--gap-between-columns)]");
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== mediaProps) {
    t3 = <FlexCenter className="relative inset-shadow-border col-span-9 aspect-16/9 overflow-hidden rounded-xl lg:order-1"><NarrativeMedia media={mediaProps} /></FlexCenter>;
    $[5] = mediaProps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = reverse ? "lg:-order-1" : "lg:order-2";
  let t5;
  if ($[7] !== t4) {
    t5 = classNames("col-span-7", t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== moduleData) {
    t6 = <TextOnly className="w-full" module={moduleData} />;
    $[9] = moduleData;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <FlexCenter className={t5}>{t6}</FlexCenter>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t7) {
    t8 = <Container asChild={true}><div className={t2}>{t3}{t7}</div></Container>;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}